export default function premade() {
    var productID = 32083,
        components = [
            {
                id: 12163,
                name: 'SmartEssentials&reg; Pellets',
                isColiCareEligible: !1,
                analysis: null,
                extraInformation: {
                    clinicalResearch: [
                        {
                            title: 'Biotin',
                            url:
                                'https://www.smartpakequine.com/content/Supplement-Ingredients-Backed-by-Research#biotin'
                        },
                        {
                            title: 'Copper',
                            url:
                                'https://www.smartpakequine.com/content/Supplement-Ingredients-Backed-by-Research#copper'
                        },
                        {
                            title: 'DHA',
                            url: 'https://www.smartpakequine.com/content/Supplement-Ingredients-Backed-by-Research#DHA'
                        },
                        {
                            title: 'Enzymes',
                            url:
                                'https://www.smartpakequine.com/content/Supplement-Ingredients-Backed-by-Research#digestiveenzymes'
                        },
                        {
                            title: 'EPA',
                            url: 'https://www.smartpakequine.com/content/Supplement-Ingredients-Backed-by-Research#EPA'
                        },
                        {
                            title: 'Leucine',
                            url:
                                'https://www.smartpakequine.com/content/Supplement-Ingredients-Backed-by-Research#leucine'
                        },
                        {
                            title: 'Lysine',
                            url:
                                'https://www.smartpakequine.com/content/Supplement-Ingredients-Backed-by-Research#lysine'
                        },
                        {
                            title: 'Omega 3 Fatty Acids',
                            url:
                                'https://www.smartpakequine.com/content/Supplement-Ingredients-Backed-by-Research#omega3'
                        },
                        {
                            title: 'Probiotics',
                            url:
                                'https://www.smartpakequine.com/content/Supplement-Ingredients-Backed-by-Research#probiotics'
                        },
                        {
                            title: 'Selenium',
                            url:
                                'https://www.smartpakequine.com/content/Supplement-Ingredients-Backed-by-Research#selenium'
                        },
                        {
                            title: 'Threonine',
                            url:
                                'https://www.smartpakequine.com/content/Supplement-Ingredients-Backed-by-Research#Threonine'
                        },
                        {
                            title: 'Vitamin C',
                            url:
                                'https://www.smartpakequine.com/content/Supplement-Ingredients-Backed-by-Research#vitaminC'
                        }
                    ],
                    clinicalResearchLink: ''
                },
                productLabelImage: {
                    type: 'label',
                    url: '//img.smartpak.com/images/views/productclass/productlabel/22163_SmartEssentials_4-2017.jpg',
                    attributes: null
                },
                productId: 2109748499
            },
            {
                id: 15005,
                name: 'Smart & Simple&trade; Flax',
                isColiCareEligible: !1,
                analysis: null,
                extraInformation: {
                    clinicalResearch: [
                        {
                            title: 'Flax Seed',
                            url:
                                'https://www.smartpakequine.com/content/Supplement-Ingredients-Backed-by-Research#FlaxSeed'
                        },
                        {
                            title: 'Omega 3 Fatty Acids',
                            url:
                                'https://www.smartpakequine.com/content/Supplement-Ingredients-Backed-by-Research#omega3'
                        }
                    ],
                    clinicalResearchLink: ''
                },
                productLabelImage: {
                    type: 'label',
                    url: '//img.smartpak.com/images/views/productclass/productlabel/25005_Flax_SmartSimple_3-2018.jpg',
                    attributes: null
                },
                productId: 2109779786
            }
        ],
        script = document.createElement('script');
    script.async = !0;
    script.onload = function() {
        window.premade(components, productID);
    };
    script.src = '/jsscripts/dycampaigns/premade.js';
    document.getElementsByTagName('head')[0].appendChild(script);
}
